const rankingItems = [
  { rank: 1, title: '暗夜追凶', type: '悬疑电影', hot: '9.8', badge: '🔥 HOT', badgeClass: 'bg-accent-500 text-background-950' },
  { rank: 2, title: '星河帝国', type: '科幻剧集', hot: '9.7', badge: '📈 飙升', badgeClass: 'bg-primary-500 text-background-950' },
  { rank: 3, title: '长安十二时辰', type: '古装悬疑', hot: '9.6', badge: '⭐ 经典', badgeClass: 'bg-secondary-500 text-background-950' },
  { rank: 4, title: '深海迷踪', type: '惊悚电影', hot: '9.5', badge: '🆕 新片', badgeClass: 'bg-accent-500/80 text-background-950' },
  { rank: 5, title: '完美世界', type: '玄幻动漫', hot: '9.4', badge: '📈 飙升', badgeClass: 'bg-primary-500 text-background-950' },
  { rank: 6, title: '极限追击', type: '动作电影', hot: '9.3', badge: '🔥 HOT', badgeClass: 'bg-accent-500 text-background-950' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-4">
            热度榜单
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            热门影视排行榜
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            实时更新，发现当下最受欢迎的影视作品
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 hover:bg-background-200/70 rounded-xl p-4 border border-background-300/20 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-bold text-lg text-foreground-300">
                {item.rank <= 3 ? (
                  <span className={item.rank === 1 ? 'text-primary-400' : item.rank === 2 ? 'text-accent-400' : 'text-secondary-400'}>
                    {`0${item.rank}`}
                  </span>
                ) : (
                  <span className="text-foreground-500">{`0${item.rank}`}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{item.type}</p>
              </div>

              <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${item.badgeClass}`}>
                {item.badge}
              </span>

              <div className="flex-shrink-0 text-right min-w-[60px]">
                <div className="text-lg md:text-xl font-heading font-bold text-primary-400">{item.hot}</div>
                <div className="text-xs text-foreground-500">热度</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}